import React from 'react';
import { Icon } from '../../../primitives/Icon';
import { Path } from 'react-native-svg';

export function Dotted(props: any) {
  return (
    <Icon color={props.color} viewBox="0 0 66.238 69" size={props.size}>
      <Path
        id="Path_33"
        data-name="Path 33"
        d="M74.735,324.332a6.22,6.22,0,1,0,4.377,1.811A5.989,5.989,0,0,0,74.735,324.332Z"
        transform="translate(-59.556 -275.343)"
      />
      <Path
        id="Path_34"
        data-name="Path 34"
        d="M22.942,198.757a6.92,6.92,0,0,0-6.9-6.9,6.645,6.645,0,0,0-4.873,2.027,6.872,6.872,0,0,0,0,9.746,6.643,6.643,0,0,0,4.873,2.027,6.643,6.643,0,0,0,4.873-2.027A6.642,6.642,0,0,0,22.942,198.757Z"
        transform="translate(-9.142 -162.878)"
      />
      <Path
        id="Path_35"
        data-name="Path 35"
        d="M346.061,93.695a3.46,3.46,0,1,0-2.437-1.014A3.323,3.323,0,0,0,346.061,93.695Z"
        transform="translate(-292.242 -73.684)"
      />
      <Path
        id="Path_36"
        data-name="Path 36"
        d="M66.983,59.388a7.582,7.582,0,1,0,5.369,2.221A7.315,7.315,0,0,0,66.983,59.388Z"
        transform="translate(-51.803 -50.418)"
      />
      <Path
        id="Path_37"
        data-name="Path 37"
        d="M399.941,211.34a4.166,4.166,0,1,0,1.207,2.933A3.99,3.99,0,0,0,399.941,211.34Z"
        transform="translate(-334.91 -178.393)"
      />
      <Path
        id="Path_38"
        data-name="Path 38"
        d="M338.3,333.473a4.859,4.859,0,1,0,3.407,1.423A4.648,4.648,0,0,0,338.3,333.473Z"
        transform="translate(-284.485 -283.104)"
      />
      <Path
        id="Path_39"
        data-name="Path 39"
        d="M206.519,383.717a5.524,5.524,0,1,0,3.9,1.618A5.322,5.322,0,0,0,206.519,383.717Z"
        transform="translate(-172.019 -325.759)"
      />
      <Path
        id="Path_40"
        data-name="Path 40"
        d="M191.007,0a7.987,7.987,0,0,0-5.866,2.415,7.987,7.987,0,0,0-2.415,5.865,7.985,7.985,0,0,0,2.415,5.865,8.33,8.33,0,0,0,11.73,0,7.985,7.985,0,0,0,2.414-5.865,7.989,7.989,0,0,0-2.414-5.865A7.984,7.984,0,0,0,191.007,0Z"
        transform="translate(-156.508 0)"
      />
    </Icon>
  );
}
